<template>
  <section class="chapter4">
    <div class="top">
      <Container>
        <CNumber>04</CNumber>
        <Title>Vrienden</Title>
        <Content>
          <p>Een borrel in de kroeg? Terwijl jij in gedachten al op de fiets zit, moet de depressieve versie van jou er niet aan denken. Die ziet het liefst zo min mogelijk mensen. En gebruikt ieder smoesje om niemand onder ogen te hoeven komen.</p>
        </Content>
      </Container>
      <Chat></Chat>
    </div>
    <div class="bottom">
      <Container>
        <Rorschach
          :src="rorschach"
          :poster="poster"
          light
        >
          Ivo
          <AudioPlayer
            :src="ivo"
            title="Luister naar Ivo"
            person="ivo"
            trackTitle="anekdote-ivo"
          ></AudioPlayer>
        </Rorschach>
        <PersonContent>
          Als ik een berichtje kreeg, zorgde ik altijd wel dat er iets was. Op zo’n moment kwam ik met smoesjes. ‘Ik heb last van mn rug, nu effe niet.’ WhatsApp-vinkjes zette ik bewust uit, dan zagen mensen niet dat ik het gelezen had.
        </PersonContent>
        <Rorschach
          :poster="poster2"
          :src="rorschach2"
          light
        >
          Maayke
          <AudioPlayer
            :src="maayke"
            title="Luister naar Maayke"
            person="maayke"
            trackTitle="anekdote-maayke"
          ></AudioPlayer>
        </Rorschach>
        <PersonContent>
          Aan Whatsapp onttrek ik me altijd een beetje. Misschien dat ik wel afspreek, voor iets over twee weken. Dat klinkt nog ver weg. Maar naarmate die datum nadert, doe ik er alles aan om het te vermijden.
        </PersonContent>
        <Accordion :track="track">
          <template slot="explanation">
            <p>Naast dat depressieve mensen zich niet goed voelen, schamen ze zich ook vaak. Over wat ze voelen en dat ze dit niet goed uit kunnen leggen. Dat zorgt soms ook voor een schuldgevoel. Bijvoorbeeld dat ze hun omgeving belasten met hun aanwezigheid en moeilijke gedachten. Depressieve mensen kunnen ook het gevoel hebben dat ze verzaken. Daardoor praten ze er pas over als de situatie vergevorderd is.</p>
          </template>
          <template slot="title">Wat zit daarachter?</template>
        </Accordion>
      </Container>
    </div>
  </section>
</template>

<script>
import { CNumber, Title, Content, Container, AudioPlayer } from '@/components/chapter'
import { Rorschach, PersonContent } from '@/components/person'
import Accordion from '@/components/Accordion'
import { Chat } from '@/components/chat'
import media from '@/utils/media'
import { mediaQueryMixin, scrollPositionMixin, chapterMixin } from '@/mixins'

export default {
  name: 'Chapter4',
  mixins: [mediaQueryMixin, scrollPositionMixin, chapterMixin],
  components: {
    CNumber,
    Title,
    Content,
    Rorschach,
    PersonContent,
    Accordion,
    Container,
    Chat,
    AudioPlayer
  },
  computed: {
    rorschach () {
      return media.chapter4.rorschach
    },
    poster () {
      return media.chapter4.poster
    },
    rorschach2 () {
      return media.chapter4.rorschach2
    },
    poster2 () {
      return media.chapter4.poster2
    },
    ivo () {
      return media.chapter4.anekdotes.ivo
    },
    maayke () {
      return media.chapter4.anekdotes.maayke
    }
  }
}
</script>

<style lang="scss" scoped>
.chapter4 {
  color: white;
  text-align: left;
  background-color: $c-light;
  position: relative;
}
.top {
  padding-top: 75px;
  padding-bottom: 75px;

  @media (min-width: 768px) {
    padding-top: 175px;
    padding-bottom: 100px;
  }
}
.bottom {
  padding-bottom: 65px;
}
</style>



// WEBPACK FOOTER //
// src/components/chapters/Chapter4.vue